// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CookieConsent--bottom:before{background:repeating-linear-gradient(90deg,#f7f0fc,#f7f0fc 3px,#f5ecfb 0,#f5ecfb 6px);content:\"\";height:.5rem;left:0;position:absolute;top:-.5rem;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
